module.exports = new __parcel__URL__("pase-pro.3a6ea199.webp").toString();